module.exports = __webpack_public_path__ + "media/src/fonts/GothamPro-Light-f44be092713bc803c628afb632f4f31b.woff";